import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { interactionBarShadow } from "@/common/style/commonStyle";

export const useStyle = makeStyles({
	grid: {
		display: "grid",
		gridTemplateColumns: "repeat(3, 1fr)",
		columnGap: "10px",
		rowGap: "15px",
		...shorthands.padding("0", "4rem", "1rem", "4rem"),
	},
	gridItem: {
		cursor: "pointer",
		display: "flex",
		flexDirection: "column",
		backgroundColor: "unset",
		justifyContent: "flex-start",
		alignItems: "center",
		color: tokens.colorBrandForegroundLink,
		...shorthands.border(0),
		...shorthands.borderRadius(tokens.borderRadiusMedium),
		...shorthands.padding("0.5rem", "0.9rem", "0.8rem"),

		navUp: "auto",
		navDown: "auto",
		navRight: "auto",
		navLeft: "auto",
	},
	gridItemHover: {
		":hover": {
			backgroundColor: tokens.colorNeutralBackground3Hover,
		},
		":focus-visible": {
			...shorthands.outline(
				tokens.strokeWidthThin,
				"solid",
				tokens.colorNeutralStroke1Selected
			),
		},
	},
	gridItemDisabled: {
		color: tokens.colorNeutralForegroundDisabled,
	},
	gridItemDigit: {
		fontSize: "24px",
		fontWeight: 400,
		lineHeight: "32px",
		letterSpacing: 0,
	},
	gridItemText: {
		fontSize: "10px",
		fontWeight: 400,
		lineHeight: "12px",
		letterSpacing: 0,
	},
	container: {
		backgroundColor: tokens.colorNeutralBackground1,
		margin: "16px",
		paddingTop: "1rem",
		...interactionBarShadow(),
	},
	outboundContainer: {
		backgroundColor: tokens.colorNeutralBackground1,
		width: "100%",
		paddingTop: "1rem",
	},
});
